module.exports = __webpack_public_path__ + "static/young_paladin_seek_guidance-9a814e9f29ba237e062cf6f975c0b4c6.png";